import styles from "./TweetSkeleton.module.scss";
import { RectangleSkeleton } from "../RectangleSkeleton/RectangleSkeleton";

const TweetSkeleton = () => {
  return (
    <div className={styles.skeletonContainer}>
      <div className={styles.horizontalElements}>
        <RectangleSkeleton height="48px" width="48px" />
        <div className={styles.verticalElements}>
          <RectangleSkeleton height="20px" width="20%" />
          <RectangleSkeleton height="25px" width="25%" />
        </div>
        <RectangleSkeleton
          height="25px"
          width="25px"
          className={styles.xIcon}
        />
      </div>
      <RectangleSkeleton height="240px" width="100%" />
    </div>
  );
};

export { TweetSkeleton };
